import React from 'react';
import { Link } from "react-router-dom";
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactRouting = () => {
  const contactRoutes = [
    {
      id: 'enrollment',
      title: 'Course Enrollment',
      description: 'Questions about courses, pricing, schedules, and getting started',
      icon: 'GraduationCap',
      features: ['Course Information', 'Pricing Details', 'Schedule Consultation', 'Enrollment Support']
    },
    {
      id: 'institutional',
      title: 'Institutional Partnerships',
      description: 'Custom training programs, enterprise solutions, and bulk enrollments',
      icon: 'Building2',
      features: ['Custom Programs', 'Enterprise Solutions', 'Demo Requests', 'Partnership Opportunities']
    },
    {
      id: 'technical',
      title: 'Technical Support',
      description: 'Platform issues, account problems, and technical assistance',
      icon: 'Settings',
      features: ['Platform Issues', 'Account Problems', 'Technical Assistance', 'Bug Reports']
    },
    {
      id: 'general',
      title: 'General Inquiries',
      description: 'Community questions, feedback, and other general information',
      icon: 'MessageSquare',
      features: ['Community Support', 'General Questions', 'Feedback', 'Suggestions']
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            How Can We Help You?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Choose the category that best matches your inquiry for faster, more personalized support
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contactRoutes.map((route) => (
            <div
              key={route.id}
              className="holographic-card p-6 transition-all duration-300 border border-border" // ✅ same border for all, no glow
            >
              <div className="text-center mb-4">
                <div className="w-16 h-16 mx-auto rounded-full bg-muted/10 flex items-center justify-center mb-4">
                  <Icon name={route.icon} size={32} className="text-foreground" /> {/* ✅ same icon color */}
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">{route.title}</h3>
                <p className="text-sm text-muted-foreground">{route.description}</p>
              </div>

              {/* Always Visible Details */}
              <div className="mt-6 pt-4 border-t border-border">
                <ul className="space-y-2 mb-4">
                  {route.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm text-muted-foreground">
                      <Icon name="Check" size={14} className="text-foreground mr-2" /> {/* ✅ same check color */}
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-6">Need immediate assistance?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact-support">
              <Button
                variant="default"
                className="morphing-cta"
                iconName="MessageCircle"
                iconPosition="left"
              >
                Send us an Email
              </Button>
            </Link>
            <Button
              variant="outline"
              iconName="Phone"
              iconPosition="left"
            >
              Call Now at +91 99208 85753
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactRouting;
